/** Normalizes JSON bodies that are either a raw array or `{ data: T[] }`. */
export function normalizeApiListPayload<T>(payload: unknown): T[] {
  if (Array.isArray(payload)) {
    return payload as T[]
  }

  if (
    payload &&
    typeof payload === 'object' &&
    Array.isArray((payload as { data?: unknown }).data)
  ) {
    return (payload as { data: T[] }).data
  }

  return []
}
